import { TaskPageEnums } from "../utils/Enums/TaskPageEnums";

export const filterKey = [
    { label: "Assignee", value: "assignee", id: "AssignedTo" },
    { label: "Planning", value: "planningName", id: "Planning" },
    { label: "Priority", value: "priority", id: "PriorityId" },
    { label: "Project", value: "projectName", id: "ProjectId" },
    { label: "Status", value: "status", id: "TaskStatusId" },
    { label: "Type", value: "taskTypeName", id: "TaskTypeId" },
];

// const defaultFilterKey = [
//     { label: "Assignee", value: "assignee", id: "AssignedTo" },
//     { label: "Planning", value: "planningName", id: "Planning" },
//     { label: "Priority", value: "priority", id: "PriorityId" },
//     { label: "Project", value: "projectName", id: "ProjectId" },
//     { label: "Status", value: "status", id: "TaskStatusId" },
//     { label: "Type", value: "taskTypeName", id: "TaskTypeId" },
// ];

const allowedValuesMap = {
    [TaskPageEnums.ALL]: ["assignee", "priority", "status", "taskTypeName"],
    [TaskPageEnums.MY_PROJECT_TASK]: ["projectName", "priority", "status", "taskTypeName"],
    [TaskPageEnums.ALL_PROJECT_TASK]: ["assignee", "priority", "status", "taskTypeName"],
    [TaskPageEnums.PROJECT_PLANNED_TASK]: ["assignee", "planningName", "priority", "status", "taskTypeName"],
    [TaskPageEnums.MY_TEAM_TASK]: ["assignee", "projectName", "priority", "status", "taskTypeName", "planningName"],
    [TaskPageEnums.TEAM_PLANNED_TASK]: ["assignee", "projectName", "priority", "status", "taskTypeName"],
    [TaskPageEnums.BACKLOG_TASK]: ["assignee", "priority", "status", "taskTypeName"],
};

export const filterDropdownKeys = (pageKey) => {
    const allowedValues = allowedValuesMap[pageKey] || [];
    return filterKey.filter(item => allowedValues.includes(item.value));
};

export const filterCompare = [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "isNot" },
];
